/**
 * How an outbound call from a configured phone number presents itself to the callee. primary owns
 * this vocabulary — its phone number configuration record stores the mode, and its
 * `/flow/data-access/phone-number-configurations/:id` endpoint returns it. Flow references it in
 * its voice-call block to decide whether to place a branded call.
 */
export var PhoneNumberCallMode;
(function (PhoneNumberCallMode) {
    PhoneNumberCallMode["Default"] = "Default";
    PhoneNumberCallMode["Branded"] = "Branded";
})(PhoneNumberCallMode || (PhoneNumberCallMode = {}));
//# sourceMappingURL=callMode.js.map